import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface ILabelProps {
  label: string
  children: ReactNode
  isNarrow?: boolean
  isBold?: boolean
}

export const Label = (props: ILabelProps) => {
  const labelClassName = classnames({
    'def-lst__narrow': props.isNarrow,
    'def-lst__tit--bold': props.isBold,
    'def-lst__tit--black': props.isBold,
  })

  const descClassName = classnames({
    'def-lst__tit--bold': props.isBold,
  })

  return (
    <>
      <dt className={labelClassName}>{props.label}</dt>
      <dd className={descClassName}>{props.children}</dd>
    </>
  )
}
